import { useWindowDimensions } from 'react-native';

export const useMiniMapWrapperStyle = () => {
  const { width: windowWidth } = useWindowDimensions();
  const { width, height } = {
    width: MINI_MAP_WIDTH(windowWidth),
    height: MINI_MAP_HEIGHT(windowWidth),
  };

  const { vertical: paddingVertical, horizontal: paddingHorizontal } =
    MINI_MAP_PADDING(windowWidth);

  return { width, height, paddingVertical, paddingHorizontal };
};

const MINI_MAP_WIDTH_LARGE = 156;
const MINI_MAP_HEIGHT_LARGE = 120;
const MINI_MAP_WIDTH_SMALL = 104;
const MINI_MAP_HEIGHT_SMALL = 80;

const MINI_MAP_BREAKPOINT = 427;

const MINI_MAP_WIDTH = (windowWidth: number): number =>
  windowWidth >= MINI_MAP_BREAKPOINT
    ? MINI_MAP_WIDTH_LARGE
    : MINI_MAP_WIDTH_SMALL;

const MINI_MAP_HEIGHT = (windowWidth: number): number =>
  windowWidth >= MINI_MAP_BREAKPOINT
    ? MINI_MAP_HEIGHT_LARGE
    : MINI_MAP_HEIGHT_SMALL;

const MINI_MAP_PADDING = (
  windowWidth: number
): { vertical: number; horizontal: number } =>
  windowWidth >= MINI_MAP_BREAKPOINT
    ? {
        horizontal: 12,
        vertical: 9,
      }
    : { horizontal: 6, vertical: 8 };
